import { LessonRepotDataType } from '../../api/student-exam';

export type LessonReportsPropsType = {
  data: LessonRepotDataType[];
};

function LessonReports({ data }: LessonReportsPropsType) {
  return (
    <table className='mx-auto my-8 w-full max-w-3xl table-auto'>
      <thead>
        <tr>
          {['درس', 'تعداد', 'درست', 'سفید', 'نادرست', 'درصد'].map(header => (
            <td key={header} className='border border-slate-800 text-center font-medium'>
              {header}
            </td>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map(({ lessonName, correctCount, wrongCount, count }) => {
          const whiteCount = count - correctCount - wrongCount;
          const result = (((3 * correctCount - wrongCount) / 3 / count) * 100).toFixed(1);
          return (
            <tr>
              <td className='border border-slate-800 text-center'>{lessonName}</td>
              <td className='border border-slate-800 text-center'>{count}</td>
              <td className='border border-slate-800 text-center'>{correctCount}</td>
              <td className='border border-slate-800 text-center'>{whiteCount}</td>
              <td className='border border-slate-800 text-center'>{wrongCount}</td>
              <td dir='ltr' className='border border-slate-800 text-center'>
                {result} %
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

export default LessonReports;
